import styled from "styled-components";

export const RootContainer = styled.div`
	.infinite-scroll-component__outerdiv {
		height: calc(100vh - 70px);
	}

	.infinite-scroll-component {
		height: 100% !important;
		overflow-x: hidden !important;
	}
`;

export const HistoryBox = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px 20px;
	gap: 8px;
	background-color: #0e1017;
	border-top: ${(props) => (props.showBorder ? "1px solid #424242" : "none")};
`;

export const DateAndAmountContainer = styled.div`
	display: flex;
	flex-direction: row;
`;
export const Date = styled.p`
	flex-grow: 1;
	color: #f9f9f9;
	/* font-family: Plus Jakarta Sans; */
	font-size: 12px;
	font-style: normal;
	font-weight: 100;
	line-height: 15px;
	text-align: left;
`;
export const Amount = styled.p`
	color: #f9f9f9;
	text-align: right;
	/* font-family: Plus Jakarta Sans; */
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 15px;
`;

export const Time = styled.p`
	color: #686b6e;
	/* font-family: Plus Jakarta Sans; */
	font-size: 12px;
	font-style: normal;
	font-weight: 300;
	line-height: 15px;
`;

export const ExpireBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: center;
	gap: 4px;
`;

export const ExpireText = styled.p`
	color: #f20000;
	/* font-family: Plus Jakarta Sans; */
	font-size: 12px;
	font-style: normal;
	font-weight: 100;
	line-height: 15px;
`;

export const ExpiredTime = styled.p`
	color: #a0a0a0;
	/* font-family: Plus Jakarta Sans; */
	font-size: 12px;
	font-style: normal;
	font-weight: 100;
	line-height: 15px;
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${(props) =>
		props.size === "large" ? "calc(100vh - 70px)" : "auto"};
`;

export const EmptyText = styled.div`
	height: calc(100vh - 70px);
	align-items: center;
	justify-content: center;
	display: flex;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #808080;
`;
